import { Utils } from "@/plugins/utils";
import router from '@/router';

export default {
    namespaced: true,
    state: {
        lstEan: [],
        ean: null,
        insert: false,
        update: false,
        loading: false,
        itemsPerPage: 20,
        search: "",
        hasNext: false
    },
    getters: {
        getUpdate(state){
            return state.update
        },
        getEan(state){
            return state.ean
        },
        getEancodigo(state){
            return state.ean.eancodigo
        },
        getSearch(state){
            return state.search
        },
        getItemsPerPage(state){
            return state.itemsPerPage
        },
    },
    mutations: {
        set(state, ean){
            state.ean = ean
            if (ean)
                state.update = true
        },
        initForm(state){
            state.insert = false
            state.update = false
            state.ean = null
        },
        setParamsDataTable(state, payload){
            state.lstEan = payload.items
            state.itemsPerPage = payload.limit
            state.hasNext = payload.hasNext
        },
        setLoading(state, loading){
            state.loading = loading
        },
        setEan(state, ean){
            state.ean = ean
        },
        setLstEan(state, lstEan){
            state.lstEan = lstEan
        },
        setHasNext(state, hasNext){
            state.hasNext = hasNext
        },
        setSearch(state, search){
            state.search = search
        },
    },
    actions: {
        initForm({ commit }){
            commit("initForm")
        },
        async find({ commit, dispatch }, { eancodigo } ){
            commit("setLoading", true)
            commit("initForm")
            await this._vm.$axios.get(`/Products/EanCodification/Find/${eancodigo}`)
            .then(response => {
                let ean = Utils.ValidateAxiosResponse(response.data);
                commit("set", ean)
            })
            .catch((error) => {
                dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
            });
            commit("setLoading", false)
        },
        save({ getters, dispatch }){
            if (getters.getUpdate){
                dispatch("update")
                return
            }
            dispatch("insert")
        },
        async insert({ commit, getters, dispatch }){
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
            await this._vm.$axios.post("/Products/EanCodification/Insert", getters.getEan )
            .then(response => {
                Utils.ValidateAxiosResponse(response.data);
                router.push("/oryxpdv/produto-codigos-ean")
                commit("setEan", null)
                return true
            })
            .catch((error) => {
                dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
                return false
            });
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
        },
        async update({ commit, getters, dispatch }){
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
            await this._vm.$axios.put("/Products/EanCodification/Update", getters.getEan )
            .then(response => {
                Utils.ValidateAxiosResponse(response.data);
                router.push("/oryxpdv/produto-codigos-ean")
                commit("setEan", null)
                return true
            })
            .catch((error) => {
                dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
                return false
            });
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
        },
        async delete({ getters, dispatch }){
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, {root: true})
            await this._vm.$axios.delete(`/Products/EanCodification/Delete/${getters.getEancodigo}`)
            .then(response => {
                Utils.ValidateAxiosResponse(response.data);
                router.push("/oryxpdv/produto-codigos-ean")
                return true
            })
            .catch((error) => {
                dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
                return false
            });
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
        },
        async findList({ commit, getters, dispatch }, eancodigo){
            commit("setLoading", true)
            commit("initForm")
            await this._vm.$axios.get(`/Products/EanCodification/FindList/${eancodigo}`)
            .then(response => {
                let lstEan = Utils.ValidateAxiosResponse(response.data);
                commit("setLstEan", lstEan)
                commit("setHasNext", lstEan.length > getters.getItemsPerPage)
            }).catch(error => {
                commit("setLstEan", [])
                dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
                return false
            })
            commit("setLoading", false)
        },
        async search({ commit, getters, dispatch }, { limit = 20, page = 1}){
            commit("setLoading", true)
            commit("initForm")
            let payload = await this._vm.$axios.get(`/Products/EanCodification/Search?search=${getters.getSearch}&limit=${limit}&page=${page}`)
            .then(response => {
                let payload = Utils.ValidateAxiosResponse(response.data);
                commit("setParamsDataTable", payload)
                return true
            })
            .catch((error) => {
                commit("setLstEan", [])
                commit("setSearch", "")
                dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
                return false
            });
            commit("setLoading", false)
            return payload
        },
    }
}